import * as types from "../types";
import _ from "lodash";

const employeeAuthReducer = (state = {}, action) => {
    switch (action.type) {
        case types.GET_ALL_EMPLOYEE_AUTH:
            return { ...state, ..._.mapKeys(action.payload, "id") };
        case types.CREATE_EMPLOYEE_AUTH:
            return { ...state, [action.payload.id]: action.payload };
        case types.UPDATE_EMPLOYEE_AUTH:
            return { ...state, [action.payload.id]: action.payload };
        case types.DELETE_EMPLOYEE_AUTH:
            return _.omit(state, action.payload);
        default:
            return state;
    }
};

export default employeeAuthReducer;
